import React from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AnimatePresence } from 'motion/react';

import { AuthProvider } from '../contexts/AuthContext';
import { Inicio } from '../pages/Inicio';
import { Login } from '../pages/Login';
import { Entradas } from '../pages/Entradas';
import { ConsultaEntradas } from '../pages/ConsultaEntradas';
import { ConsultaEntradaDetalle } from '../pages/ConsultaEntradaDetalle';
import { EditarEntrada } from '../pages/EditarEntrada';
import { ComparativaAlmacenes } from '../pages/ComparativaAlmacenes';
import { HistoricoVariedad } from '../pages/HistoricoVariedad';
import { Configuracion } from '../pages/Configuracion';
import { Informes } from '../pages/Informes';
import { PrivateLayout } from './PrivateLayout';
import { PrivateRoute } from './PrivateRoute';


const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait" initial={false}>
            <Routes location={location}>
                <Route path='/login' element={<Login />} ></Route>
                <Route element={<PrivateRoute />}>
                    <Route element={<PrivateLayout />}>
                        <Route path='/' element={<Inicio />} ></Route>
                        <Route path='/entradas' element={<Entradas />} ></Route>
                        <Route path='/consulta-entradas' element={<ConsultaEntradas />} ></Route>
                        <Route path='/consulta-entradas/:codigo' element={<ConsultaEntradaDetalle />} ></Route>
                        <Route path='/consulta-entradas/:codigo/editar' element={<EditarEntrada />} ></Route>
                        <Route path='/comparativa-almacenes' element={<ComparativaAlmacenes />} ></Route>
                        <Route path='/historico-variedad' element={<HistoricoVariedad />} ></Route>
                        <Route path='/informes' element={<Informes />} ></Route>
                        {/* <Route path='/configuracion' element={<Configuracion />} ></Route> */}
                    </Route>
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </AnimatePresence>
    );
};


export const Router = () => {

    const theme = createTheme({
        palette: {
            mode: 'light',
            primary: {
                main: '#ff7900',
                light: '#ff9838',
                dark: '#c95700',
                contrastText: '#ffffff'
            },
            secondary: {
                main: '#071017',
                light: '#0d1821',
                dark: '#03080d',
                contrastText: '#ffffff'
            },
            background: {
                default: '#f6f7f8',
                paper: '#ffffff'
            },
            text: {
                primary: '#15191d',
                secondary: '#68727d'
            },
            success: {
                main: '#079455'
            },
            warning: {
                main: '#ff8800'
            },
            info: {
                main: '#1570ef'
            },
            error: {
                main: '#d92d20',
                contrastText: '#ffffff'
            },
            divider: '#e8eaed'
        },
        typography: {
            fontFamily: '"Bariol", "Inter", "Segoe UI", Arial, sans-serif',
            h1: {
                fontSize: '30px',
                fontWeight: 700,
                lineHeight: '38px',
                letterSpacing: 0
            },
            h2: {
                fontSize: '22px',
                fontWeight: 700,
                lineHeight: '30px',
                letterSpacing: 0
            },
            h3: {
                fontSize: '18px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: 0
            },
            body1: {
                fontSize: '15px',
                lineHeight: '21px',
                letterSpacing: 0
            },
            body2: {
                fontSize: '14px',
                lineHeight: '19px',
                letterSpacing: 0
            },
            button: {
                fontSize: '15px',
                fontWeight: 700,
                letterSpacing: 0,
                textTransform: 'none'
            }
        },
        shape: {
            borderRadius: 8
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        minHeight: 40,
                        borderRadius: 6,
                        fontWeight: 700
                    }
                }
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        border: '1px solid #e8eaed',
                        boxShadow: '0 8px 22px rgba(17,24,39,0.05)'
                    }
                }
            },
            MuiTextField: {
                defaultProps: {
                    size: 'small'
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontSize: 14,
                        fontWeight: 700,
                        color: '#68727d'
                    },
                    shrink: {
                        fontSize: 13,
                        fontWeight: 700
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    input: {
                        fontSize: 15,
                        fontWeight: 400
                    }
                }
            },
            MuiTable: {
                defaultProps: {
                    size: 'small'
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        fontSize: 14
                    },
                    head: {
                        fontWeight: 700
                    }
                }
            },
        }
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <AuthProvider>
                    <Box
                        className='outfit load'
                        sx={{
                            minHeight: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                            bgcolor: 'background.default',
                            color: 'text.primary'
                        }}
                    >
                        <AnimatedRoutes />
                    </Box>
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    )
}
